import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofz22V4Bg } from './pages-map'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4_BG: Record<
  Exclude<PageIdWoofz22V4Bg, PageIdWoofz22V4Bg.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofz22V4Bg.SEX_22V4_BG]: {
    id: PageIdWoofz22V4Bg.SEX_22V4_BG,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Bg.DOG_AGE_22V4_BG]: {
    id: PageIdWoofz22V4Bg.DOG_AGE_22V4_BG,
    progressBar: 'controlled',
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Bg.DOG_BREED_22V4_BG]: {
    id: PageIdWoofz22V4Bg.DOG_BREED_22V4_BG,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Bg.DOG_BREED_ID_22V4_BG]: {
    id: PageIdWoofz22V4Bg.DOG_BREED_ID_22V4_BG,
  },
  [PageIdWoofz22V4Bg.URGE_22V4_BG]: {
    id: PageIdWoofz22V4Bg.URGE_22V4_BG,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Bg.COMMANDS_61_22V4_BG]: {
    id: PageIdWoofz22V4Bg.COMMANDS_61_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Bg.COMMANDS_62_22V4_BG]: {
    id: PageIdWoofz22V4Bg.COMMANDS_62_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Bg.COMMANDS_63_22V4_BG]: {
    id: PageIdWoofz22V4Bg.COMMANDS_63_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Bg.URGE_2_22V4_BG]: {
    id: PageIdWoofz22V4Bg.URGE_2_22V4_BG,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Bg.POTTY_22V4_BG]: {
    id: PageIdWoofz22V4Bg.POTTY_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Bg.BEHAVIOR_22V4_BG]: {
    id: PageIdWoofz22V4Bg.BEHAVIOR_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Bg.TRAINING_22V4_BG]: {
    id: PageIdWoofz22V4Bg.TRAINING_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4Bg.PREPARE_FLOW_22V4_BG]: {
    id: PageIdWoofz22V4Bg.PREPARE_FLOW_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Bg.DOG_STATISTICS_22V4_BG]: {
    id: PageIdWoofz22V4Bg.DOG_STATISTICS_22V4_BG,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofz22V4Bg.EMAIL_22V4_BG]: {
    id: PageIdWoofz22V4Bg.EMAIL_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Bg.NEWSLETTER_URGE_22V4_BG]: {
    id: PageIdWoofz22V4Bg.NEWSLETTER_URGE_22V4_BG,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4Bg.LAST_CHANCE_OFFER_22V4_BG]: {
    id: PageIdWoofz22V4Bg.LAST_CHANCE_OFFER_22V4_BG,
  },
  [PageIdWoofz22V4Bg.WELCOME_TO_WOOFZ_22V4_BG]: {
    id: PageIdWoofz22V4Bg.WELCOME_TO_WOOFZ_22V4_BG,
    hasHeader: true,
  },
  [PageIdWoofz22V4Bg.SUBSCRIPTIONS_22V4_BG]: {
    id: PageIdWoofz22V4Bg.SUBSCRIPTIONS_22V4_BG,
  },
  [PageIdWoofz22V4Bg.CANCEL_OFFER_22V4_BG]: {
    id: PageIdWoofz22V4Bg.CANCEL_OFFER_22V4_BG,
  },
  [PageIdWoofz22V4Bg.CHAT_UPSELL_22V4_BG]: {
    id: PageIdWoofz22V4Bg.CHAT_UPSELL_22V4_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4Bg.UPSELL_22V4_BG]: {
    id: PageIdWoofz22V4Bg.UPSELL_22V4_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4Bg.UPSELL_FEEDING_GUIDE_22V4_BG]: {
    id: PageIdWoofz22V4Bg.UPSELL_FEEDING_GUIDE_22V4_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4Bg.UPSELL_EMOTIONAL_SUPPORT_22V4_BG]: {
    id: PageIdWoofz22V4Bg.UPSELL_EMOTIONAL_SUPPORT_22V4_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4Bg.DOWNLOAD_22V4_BG]: {
    id: PageIdWoofz22V4Bg.DOWNLOAD_22V4_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
